// @ts-nocheck

import React, { useCallback } from 'react';
import { createPortal } from 'react-dom';

import { getPortalRootDOMElement } from '../../DOMElements';
import useRouter from '../../hooks/useRouter';
import GridsHelpMatchContainer from '../../modules/grids/containers/GridsHelpMatchContainer';
import GridsTutoContainer from '../../modules/grids/containers/GridsTutoContainer';
import { isGridHelpOpen, isGridStatsOpen } from '../../modules/grids/utils/routes';
import { Modal as ModalTheme } from '../../styled-components/dark/modal';
import Modal from '../Modal';
import ScaleRouteTransitionGroup from '../ScaleRouteTransitionGroup';

/**
 * Display the modals for the grids section

 */
const DesktopGridsModalLayout = () => {
  const { history, location } = useRouter();
  const matchId = location.state?.matchId;
  const isHelpOpen = isGridHelpOpen(location);
  const isStatsOpen = isGridStatsOpen(location);

  const closeModal = useCallback(() => {
    history.push(location.pathname);
  }, [history, location.pathname]);

  const isModalOpen = isHelpOpen || isStatsOpen;

  return createPortal(
    <>
      <ScaleRouteTransitionGroup>
        {isModalOpen ? (
          <Modal
            backgroundColor={ModalTheme.backgroundColor.default}
            closeOnOutsideClick
            closeOnEsc
            onClose={closeModal}
            hasOverlay
            hasCloseButton
            isGrid
          >
            <>
              {isStatsOpen ? <GridsHelpMatchContainer matchId={matchId} /> : isHelpOpen ? <GridsTutoContainer /> : null}
            </>
          </Modal>
        ) : null}
      </ScaleRouteTransitionGroup>
    </>,
    getPortalRootDOMElement(),
  );
};

export default DesktopGridsModalLayout;
